module.exports = __webpack_public_path__ + "static/img/cyx1.11eae6b3.png";